import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { HOME } from '@/constants/testIds';

const ACCENT_CLASS = {
  pink: { num: 'pg-neon-text', label: 'pg-text-glow-pink', cta: 'pg-text-glow-pink', tile: '' , border: 'rgba(255,62,165,0.20)' },
  emerald: { num: 'pg-neon-text-emerald', label: 'pg-text-glow-emerald', cta: 'pg-text-glow-emerald', tile: 'tile-emerald', border: 'rgba(25,194,142,0.20)' },
  gold: { num: 'pg-neon-text-gold', label: 'pg-text-glow-gold', cta: 'pg-text-glow-gold', tile: 'tile-gold', border: 'rgba(226,199,122,0.22)' },
};

export function ChannelTile({ to, number, label, description, cta, image, accent = 'pink', index = 0 }) {
  const a = ACCENT_CLASS[accent] || ACCENT_CLASS.pink;
  return (
    <motion.div
      initial={{ opacity: 1, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.06, ease: [0.16,1,0.3,1] }}
    >
      <Link
        to={to}
        data-testid={HOME.channelTile}
        className={`pg-channel-tile ${a.tile} block group min-h-[300px] sm:min-h-[360px]`}
        style={{ borderColor: a.border }}
      >
        {/* image */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-50 group-hover:opacity-70 group-hover:scale-[1.04] transition-all duration-700"
          style={{ backgroundImage: `url('${image}')`, filter: 'saturate(0.95)' }}
          aria-hidden
        />
        <div className="absolute inset-0" style={{
          background: 'linear-gradient(180deg, rgba(7,8,15,0.10) 0%, rgba(7,8,15,0.78) 65%, rgba(7,8,15,0.96) 100%)',
        }} aria-hidden />

        <div className="relative h-full p-6 sm:p-7 flex flex-col justify-between">
          <div className="flex items-baseline gap-3">
            <span className={`font-display text-3xl sm:text-4xl ${a.num}`}>{String(number).padStart(2,'0')}</span>
            <span className={`font-display text-2xl sm:text-3xl tracking-[0.22em] ${a.label}`} data-caps-target>{label}</span>
          </div>

          <div>
            <p className="text-[var(--pg-ink)] text-sm sm:text-base leading-relaxed max-w-xs">{description}</p>
            <div className={`mt-5 inline-flex items-center gap-2 font-display tracking-[0.22em] text-xs sm:text-sm ${a.cta}`}>
              {cta}
              <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
